import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { CoreDirectivesModule } from '@core/directives/directives';
import { TranslocoModule } from '@jsverse/transloco';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { FileSizePipe } from 'app/pipes/file-size.pipe';
 
import { Subject } from 'rxjs';

@Component({
  selector: 'app-basic-file-upload',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslocoModule,
    NgbProgressbarModule,
    CoreDirectivesModule,
    FileSizePipe
  ],
  templateUrl: './basic-file-upload.component.html',
  styleUrls: ['./basic-file-upload.component.scss']
})
export class BasicFileUploadComponent implements OnInit, OnDestroy{
  @Input({required: true}) file: File;
  @Input() progress: number = 0;
  @Input() formGroupName: number;

  @Output() delete: EventEmitter<File> = new EventEmitter();


    public form: FormGroup;
    private onDestroy$: Subject<void> = new Subject<void>();

    constructor(
        private rootFormGroup: FormGroupDirective
    ) {

    }

    ngOnInit(): void {
         this.form = (this.rootFormGroup.control?.get('files') as FormGroup).controls[this.formGroupName] as FormGroup;
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    onDelete(): void {
        this.delete.next(this.file);
    }
 
}
